export const types = {
    SET_GET_PROVIDERS: '[GAMES] SET GET PROVIDERS',
    SET_GET_GAMES: '[GAMES] SET GET GAMES',
    SET_GET_GAME_BY_ID: '[GAMES] SET GET GAME BY ID',
    SET_GET_PROVIDER_BY_ID: '[GAMES] SET GET PROVIDER BY ID',
}